import type { CurrentRefinementsConnectorParamsRefinement } from 'instantsearch.js/es/connectors/current-refinements/connectCurrentRefinements';

const attributeLabelMap: Record<string, string> = {
  brand: 'filter.menu.filter.brand',
  productSubType: 'filter.menu.filter.style',
  Material: 'filter.menu.filter.material',
  fit: 'filter.menu.filter.width',
  'review.rating': 'filter.menu.filter.top.rated',
  gender: 'filter.menu.filter.gender',
  Type: 'filter.menu.filter.product.type',
  fastening: 'filter.menu.filter.fastening',
  heel: 'filter.menu.filter.heel.height',
  technologies: 'filter.menu.filter.technology',
  size: 'filter.menu.filter.size',
  color: 'filter.menu.filter.colour',
};

export function createRefinementLabel(
  attribute: CurrentRefinementsConnectorParamsRefinement['attribute'],
  value: CurrentRefinementsConnectorParamsRefinement['value'],
) {
  const entry = Object.entries(attributeLabelMap).find(([key]) => attribute.includes(key));

  if (entry) {
    const [key, label] = entry;
    return {
      label,
      value: key === 'size' ? value.toString().split('_')[0] : value,
    };
  }

  return {
    label: '',
    value,
  };
}
